<template>
  <a-modal
    title="编辑阶段"
    :width="800"
    :visible="visible"
    :maskClosable="false"
    okText="保存"
    @cancel="close"
    @ok="confirm"
    :confirmLoading="confirmLoading"
  >
    <a-form-model ref="ruleForm" :model="queryParams" :rules="rules" layout="inline" :labelCol="{ style: { width: '80px' } }">
      <a-row>
        <a-col :md="8" :sm="24">
          <a-form-model-item label="序号" prop="stageNumber">
            <a-input-number v-model="queryParams.stageNumber" :min="1" />
          </a-form-model-item>
        </a-col>
        <a-col :md="8" :sm="24">
          <a-form-model-item label="阶段名称" prop="stageCode">
            <global-select
              :value.sync="queryParams.stageCode"
              :selectData="stageCodeList"
              :selectItem="{ value: 'lookupCode', label: 'lookupValue' }"
              :disabled="true"
            />
          </a-form-model-item>
        </a-col>
        <a-col :md="8" :sm="24">
          <a-form-model-item label="说明">
            <a-input v-model="queryParams.remark" disabled />
          </a-form-model-item>
        </a-col>
      </a-row>
      <a-row>
        <a-col :md="8" :sm="24">
          <a-form-model-item label="必须步骤">
            <a-switch :checked="queryParams.necessaryFlag === 'Y'" @change="statusOnChange(queryParams, 'necessaryFlag')" />
          </a-form-model-item>
        </a-col>
        <!-- <a-col :md="8" :sm="24">
          <a-form-model-item label="自动执行下一步" :labelCol="{ style: { width: '110px' } }">
            <a-switch :checked="queryParams.nextStepFlag === 'Y'" @change="statusOnChange(queryParams, 'nextStepFlag')" />
          </a-form-model-item>
        </a-col> -->
      </a-row>
    </a-form-model>
    <div class="mt10 table-title">阶段详情</div>
    <a-table
      :columns="columns"
      :data-source="tableList"
      :pagination="false"
      row-key="id"
      :scroll="{ y: 180 }"
    >
      <template v-for="item in columns" :slot="item.dataIndex" slot-scope="text, record">
        <div :key="item.dataIndex">
          <span v-if="item.type === 'switch'">
            <a-switch :checked="record[item.dataIndex] === 'Y'" @change="statusTableOnChange(record, item.dataIndex)" />
          </span>
          <span v-else>{{ text }}</span>
        </div>
      </template>
    </a-table>
    <!-- 底部分页按钮 -->
    <Page v-show="false" ref="page" :pageParams.sync="pageParams" @getList="getList" />
  </a-modal>
</template>

<script>
import { apiScpMrpPlanStagesDetailUpdate } from '@/api/scp/planSetting/mrpPlanName'

export default {
  props: {
    stageCodeList: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  data () {
    return {
      pageParams: {
        automatic: false,
        pageUrl: '/scp/scpMrpPlanStagesDetail/list',
        tableLoading: false,
        pageSize: 999999
      },
      // 当前控件配置:
      confirmLoading: false,
      visible: false,
      columns: [
        {
          title: '执行内容',
          dataIndex: 'content'
        },
        {
          title: '说明',
          dataIndex: 'remark',
          ellipsis: true
        },
        {
          title: '启用',
          width: 140,
          dataIndex: 'enableFlag',
          scopedSlots: { customRender: 'enableFlag' },
          type: "switch"
        }
      ],
      tableList: [],
      queryParams: {
        stageId: undefined,
        stageNumber: undefined,
        stageCode: undefined,
        remark: undefined,
        necessaryFlag: undefined,
        nextStepFlag: undefined
      },
      // 表单校验
      rules: {
        stageNumber: [{ required: true }],
        stageCode: [{ required: true }]
      }
    }
  },
  created () {},
  methods: {
    show (val) {
      this.queryParams = val
      this.queryParams.stageId = val.id
      this.visible = true
      this.$nextTick(() => {
        this.$refs.page.getFirstPage(this.queryParams)
      })
    },
    // 关闭模态框
    close () {
      this.reset()
      this.visible = false
    },
    // 保存
    confirm () {
      if (!this.queryParams.stageNumber) {
        this.$message.warning('序号不能为空！')
        return
      }
      if (!this.queryParams.stageCode) {
        this.$message.warning('阶段名称不能为空！')
        return
      }
      this.confirmLoading = true

      const params = {
        ...this.queryParams,
        stageId: this.queryParams.id,
        detailList: this.tableList
      }
      apiScpMrpPlanStagesDetailUpdate(params).then(response => {
        if (response.code === 200) {
          this.$message.success('保存成功')
          // 关闭本组件
          this.visible = false
          // 调用外部刷新列表方法
          this.$emit('handle-success')
          // 刷新表单
          this.reset()
          this.confirmLoading = false
        } else {
          this.$message.error(response.msg)
          this.confirmLoading = false
        }
      }).catch(e => {
        this.confirmLoading = false
      })
    },
    // 表单重置
    reset () {
      this.queryParams = {
        stageId: undefined,
        stageNumber: undefined,
        stageCode: undefined,
        remark: undefined,
        necessaryFlag: undefined,
        nextStepFlag: undefined
      }
      this.tableList = []
    },
    /** 查询列表 */
    getList (data) {
      this.tableList = data
    },
    statusTableOnChange (record, dataIndex) {
      record[dataIndex] = record[dataIndex] === 'Y' ? 'N' : 'Y'
    },
    statusOnChange (queryParams, val) {
      queryParams[val] = queryParams[val] === 'Y' ? 'N' : 'Y'
    }
  }
}
</script>

<style scoped lang="less">
input{
  width: 140px !important;
}
/deep/.ant-input-number {
  width: 140px !important;
}
/deep/.ant-select {
  width: 140px !important;
}
/deep/.ant-modal-body{
  height: 400px;
  overflow-y: scroll;
}
.table-title{
  font-size: 16px;
  font-weight: bold;
}
</style>
